import React from "react";
import { Language } from "../../../../../../../../../../types/language.type";
import cx from "classnames";
import { FlyerDetailPageFormPositionLanguageSelectProps } from "./flyer-detail-page-form-position-language-select.props";
import {
  HostContainer,
  SelectIcon,
} from "./flyer-detail-page-form-position-language-select.styles";

export const FlyerDetailPageFormPositionLanguageSelect = (
  props: FlyerDetailPageFormPositionLanguageSelectProps
) => {
  const isSelected = (language: Language) => props.selectedLanguage === language;

  const select = (language: Language) => () => props.onSelect(language);

  return (
    <HostContainer>
      <SelectIcon onClick={select("en")} className={cx({ selected: isSelected("en") })}>
        EN
      </SelectIcon>
      <SelectIcon onClick={select("fr")} className={cx({ selected: isSelected("fr") })}>
        FR
      </SelectIcon>
    </HostContainer>
  );
};
